import FormattedMessage from 'I18n/components/FormattedMessage';
import Small from 'UIComponents/elements/Small';
import UITruncateString from 'UIComponents/text/UITruncateString';
import { View } from 'foundations-components/components/View';
import MobilePanel from 'marketplace-ui-common/components/mobile/MobilePanel';
import MobilePanelBody from 'marketplace-ui-common/components/mobile/MobilePanelBody';
import MobilePanelHeader from 'marketplace-ui-common/components/mobile/MobilePanelHeader';
import { MobilePanelHeaderBackButton, MobilePanelHeaderRightButton } from 'marketplace-ui-common/components/mobile/MobilePanelHeaderButton';
import MobilePanelNavItem from 'marketplace-ui-common/components/mobile/MobilePanelNavItem';
import { useContext } from 'react';
import { MobileFilterPanelContext } from './MobileFilterPanelContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function MobileFilterPanelItem({
  children,
  filterKey,
  panelTitle,
  subtitle,
  title
}) {
  const {
    openFilterPanel,
    onApplyFilters,
    onCloseFilterPanel,
    onOpenFilterPanel
  } = useContext(MobileFilterPanelContext);
  return /*#__PURE__*/_jsx(MobilePanelNavItem, {
    onClickItem: () => onOpenFilterPanel(filterKey),
    title: /*#__PURE__*/_jsxs("div", {
      children: [title, subtitle && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Small, {
          use: "help",
          children: /*#__PURE__*/_jsx(UITruncateString, {
            children: subtitle
          })
        })]
      })]
    }),
    children: /*#__PURE__*/_jsx(MobilePanel, {
      open: openFilterPanel === filterKey,
      children: /*#__PURE__*/_jsxs("div", {
        "data-test-id": `mobile-filter-panel-${filterKey}`,
        children: [/*#__PURE__*/_jsx(MobilePanelHeader, {
          itemLeft: /*#__PURE__*/_jsx(MobilePanelHeaderBackButton, {
            autoFocus: true,
            onClick: () => onCloseFilterPanel(),
            tabIndex: 0,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "appMarketplace.storefront.mobileNavigation.back"
            })
          }),
          itemRight: /*#__PURE__*/_jsx(MobilePanelHeaderRightButton, {
            onClick: onApplyFilters,
            tabIndex: 1,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "appMarketplace.storefront.filters.apply"
            })
          }),
          title: panelTitle || title
        }), /*#__PURE__*/_jsx(MobilePanelBody, {
          children: /*#__PURE__*/_jsx(View, {
            paddingBlock: "200",
            paddingInline: "600",
            children: children
          })
        })]
      })
    })
  });
}